/**
 * 封装些共用的过滤器
 */
const toFixed = function(value){
	const [integer, decimal = '00'] = value.toString().split('.');
	return integer + '.' + (decimal + '00').substr(0, 2);
}
const filter = {
	/**
	 * 将 boolean 转换成 文字是否
	 * @param value
	 * @returns {string}
	 */
	booleanToText: function (value) {
		return value ? '是' : '否'
	},
	money: function (value) {
		// if (isNaN(value)) {
		// 	return 0
		// }
		// if (value == 0) {
		// 	return 0
		// } else {
		// 	return (value / 10000).toFixed(2)
		// }
		if(value==0){
			return '0.00'
		}
		if (value == null || value == '' || value == undefined) {
			return '--'
		}

		var flag = true;
		if (value < 0) {
			flag = false;
			value = value * -1;
		}
		if (value > 100 && value < 100000000) {
			value = value ? (value / 10000).toFixed(2) : 0;
			value += " 万 "
		} else if (value > 100000000) {
			value = value ? (value / 100000000).toFixed(2) : 0;
			value += " 亿 "
		} else {
			value += " 元 "
		}
		if (flag) {
			return value
		} else {
			return "-" + value;
		}

	},
	money2: function (value) {
		if(value==0){
			return '0.00'
		}
		if (value == null || value == '' || value == undefined) {
			return '--'
		}
		var flag = true;
		if (value < 0) {
			flag = false;
			value = value * -1;
		}
		if (value > 100 && value < 100000000) {
			const num = value ? value / 10000 : 0;
      value = toFixed(num) + ' 万 ';
		} else if (value > 100000000) {
			const num = value ? value / 100000000 : 0;
      value = toFixed(num) + ' 亿 ';
		} else {
			value += " 元 "
		}
		if (flag) {
			return value
		} else {
			return "-" + value;
		}
	},
}

export default filter
